import { useState } from 'react';
import { useMapEvents } from 'react-leaflet';
import { makeStyles } from '@mui/styles';
import { GEOFENCE_COLORS } from '../../../hooks/useVisitGeofences';

const useStyles = makeStyles(() => ({
  legendContainer: {
    position: 'absolute',
    bottom: '20px',
    left: '10px',
    padding: '10px 12px',
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
    borderRadius: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    fontSize: '12px',
    zIndex: 1000,
    width: '210px',
  },
  title: {
    fontWeight: 700,
    color: '#4c1d95',
    marginBottom: '6px',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  },
  swatch: {
    width: '20px',
    height: '14px',
    marginRight: '8px',
    borderRadius: '3px',
    flexShrink: 0,
  },
  line: {
    width: '22px',
    height: '0px',
    marginRight: '8px',
    flexShrink: 0,
  },
  dot: {
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    marginRight: '8px',
    marginLeft: '3px',
    flexShrink: 0,
  },
  pin: {
    width: '14px',
    marginRight: '8px',
    marginLeft: '3px',
    flexShrink: 0,
    display: 'flex',
  },
}));

const VisitMapLegend = () => {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);

  useMapEvents({
    mousemove() {
      setIsHovered(true);
    },
    mouseout() {
      setIsHovered(false);
    },
  });

  if (!isHovered) return null;

  return (
    <div className={classes.legendContainer}>
      <div className={classes.title}>Legend</div>

      {/* Geofence tiers */}
      <div className={classes.legendItem}>
        <div className={classes.swatch} style={{ backgroundColor: `${GEOFENCE_COLORS.green}2e`, border: `2px solid ${GEOFENCE_COLORS.green}` }} />
        <span>Most recent closest facility</span>
      </div>
      <div className={classes.legendItem}>
        <div className={classes.swatch} style={{ backgroundColor: `${GEOFENCE_COLORS.yellow}2e`, border: `2px dashed ${GEOFENCE_COLORS.yellow}` }} />
        <span>Closest facility (journey)</span>
      </div>
      <div className={classes.legendItem}>
        <div className={classes.swatch} style={{ backgroundColor: `${GEOFENCE_COLORS.purple}1f`, border: `2px solid ${GEOFENCE_COLORS.purple}` }} />
        <span>Facility geofence</span>
      </div>

      {/* Journey trail */}
      <div className={classes.legendItem}>
        <div className={classes.line} style={{ borderTop: '3px dashed #eab308' }} />
        <span>Journey trail</span>
      </div>

      {/* Sighting dot */}
      <div className={classes.legendItem}>
        <div className={classes.dot} style={{ backgroundColor: '#c4b5fd', border: '2px solid #7c3aed' }} />
        <span>Sighting</span>
      </div>

      {/* Start / End flags */}
      <div className={classes.legendItem}>
        <span className={classes.pin}>
          <svg width='14' height='16' viewBox='0 0 28 36' xmlns='http://www.w3.org/2000/svg'>
            <line x1='4' y1='2' x2='4' y2='34' stroke='#15803d' strokeWidth='3' strokeLinecap='round' />
            <polygon points='4,2 24,8 4,14' fill='#16a34a' stroke='#15803d' strokeWidth='1' />
          </svg>
        </span>
        <span>Start of journey</span>
      </div>
      <div className={classes.legendItem}>
        <span className={classes.pin}>
          <svg width='14' height='16' viewBox='0 0 28 36' xmlns='http://www.w3.org/2000/svg'>
            <line x1='4' y1='2' x2='4' y2='34' stroke='#b91c1c' strokeWidth='3' strokeLinecap='round' />
            <polygon points='4,2 24,8 4,14' fill='#dc2626' stroke='#b91c1c' strokeWidth='1' />
          </svg>
        </span>
        <span>End of journey</span>
      </div>

      {/* Reader pin */}
      <div className={classes.legendItem}>
        <span className={classes.pin}>
          <svg width='12' height='16' viewBox='0 0 24 32' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12 0C5.4 0 0 5.4 0 12C0 21 12 32 12 32S24 21 24 12C24 5.4 18.6 0 12 0Z' fill='purple' />
            <circle cx='12' cy='12' r='5' fill='white' />
            <circle cx='12' cy='12' r='2.5' fill='purple' />
          </svg>
        </span>
        <span>Closest reader</span>
      </div>
    </div>
  );
};

export default VisitMapLegend;
